/**
 * AnooreHR's email addresses as the app shows them: one list, each address with one job
 * (founder's address table, 2026-10-11). Mirrors `website/src/lib/contacts.ts`.
 *
 * Mail to these lands in Console:
 *   - support@  help requests -> Sidekick Support (agent replies come from here)
 *   - billing@  receipts, invoices, payment questions -> Sidekick Billing
 *   - vine@     AI help: Vine answers from help articles or hands over to Sidekick
 *   - hello@    contact and enquiry forms -> Wave
 *   - status@   service status questions -> Sidekick Support
 *
 * noreply@ is only a From address (replies to it become support tickets), so the app never offers
 * it as a contact. news@ and ola@ are not app addresses.
 */
export const EMAIL = {
  support: 'support@anoorehr.com',
  billing: 'billing@anoorehr.com',
  vine: 'vine@anoorehr.com',
  hello: 'hello@anoorehr.com',
  status: 'status@anoorehr.com',
} as const;
